const WEB_BASE = 'https://mosquepay.org/mosquepayapi/v1/api/'

module.exports = { WEB_BASE }
